import React, { useEffect } from "react";
import { FaReact, FaPython } from "react-icons/fa";
import { SiDjango, SiJavascript, SiPostgresql } from "react-icons/si";
import { BsFillBootstrapFill } from "react-icons/bs";
import { IoLogoCss3 } from "react-icons/io";
import { AiFillHtml5 } from "react-icons/ai";
import { DiFirebase } from "react-icons/di";
import Aos from "aos";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="about" id="about">
      <div className="container">
        <div className="common col-sm-12">
          <h3 className="main-header">About Me</h3>
          <div className="common-border"></div>
        </div>
        <div className="row aligncenter">
          <div className="col-md-6">
            <div className="about-img">
              <img
                className="img-responsive"
                src="/images/about-img.png"
                alt="img"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="about-info">
              <h1 className="about-info-h1">Hi There!</h1>
              <p data-aos="fade-up">
                I am a computer science student, currently at Honours level. A
                junior web developer with both front end and back end
                development skills. I have serious passion for programming, web
                and application development and software engineering as a whole.
              </p>
              <p data-aos="fade-up">
                I learned a lot of computer science concepts in my course that i
                can apply in real life situations. That includes{" "}
                <b>
                  Databases, Data Analytics, Machine Learning (AI), System
                  Engineering, Computer Networking and Computer Security.
                </b>
              </p>
              <p data-aos="fade-up" className="font-weight-bold text-info">
                I HAVE TECHNICAL SKILLS AND EXPERIENCE WITH THE FOLLOWING:
              </p>

              <div className="row skills">
                <div
                  data-aos="fade-right"
                  data-aos-delay="1000"
                  className="col-xs-1 skill"
                >
                  <FaReact className="skill-icon text-info" />
                  <p>ReactJS</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="900"
                  className="col-xs-1 skill"
                >
                  <SiDjango className="skill-icon text-success" />
                  <p>Django</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="800"
                  className="col-xs-1 skill"
                >
                  <AiFillHtml5 className="skill-icon text-danger" />
                  <p>Html5</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="700"
                  className="col-xs-1 skill"
                >
                  <IoLogoCss3 className="skill-icon text-primary" />
                  <p>CSS</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="600"
                  className="col-xs-1 skill"
                >
                  <BsFillBootstrapFill className="skill-icon text-info" />
                  <p>Bootstrap</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="400"
                  className="col-xs-1 skill"
                >
                  <FaPython className="skill-icon text-primary" />
                  <p>Python</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="300"
                  className="col-xs-1 skill"
                >
                  <SiJavascript className="skill-icon text-warning" />
                  <p>JavaScript</p>
                </div>
                <div
                  data-aos="fade-right"
                  data-aos-delay="100"
                  className="col-xs-1 skill"
                >
                  <DiFirebase className="skill-icon text-warning" />
                  <p>Firebase</p>
                </div>
              </div>
              <div className="row contact-info">
                <div className="col-sm-6">
                  <strong className="text-info">Name:</strong>
                  <a href="tel:+27716488958">
                    <p>Johannes Kgatle</p>
                  </a>
                </div>
                <div className="col-sm-6">
                  <strong className="text-info">Email:</strong>
                  <a href="mailto: kgatle280@gmail.com">
                    <p>kgatle280@gmail.com</p>
                  </a>
                </div>
                <div className="col-sm-6">
                  <strong className="text-info">Phone:</strong>
                  <a href="tel:+27716488958">
                    <p>+27716488958</p>
                  </a>
                </div>
                <div className="col-sm-6">
                  <strong className="text-info">LinkedIn:</strong>
                  <a
                    href="https://www.linkedin.com/in/matome-kgatle-73aaab1b0/"
                    className="text-white text-decoration-none"
                  >
                    <p>Matome Kgatle</p>
                  </a>
                </div>
                <a
                  href="/images/Johannes Kgatle CV.pdf"
                  target="_blank"
                  type="button"
                  className="cv-btn"
                  download
                >
                  DOWNLOAD CV
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
